var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Night_On",
    d: "M9.309 0C4.1651 0 0 4.47768 0 10C0 15.5223 4.1651 20 9.309 20C11.833 20 14.1197 18.9196 15.7982 17.1696C16.0065 16.9509 16.0606 16.6116 15.9273 16.3348C15.7941 16.058 15.5067 15.9018 15.2193 15.9554C14.8111 16.0312 14.3946 16.0714 13.9656 16.0714C9.9296 16.0714 6.65583 12.5536 6.65583 8.21429C6.65583 5.27679 8.15527 2.71875 10.3753 1.37054C10.6293 1.21429 10.7585 0.901786 10.696 0.598214C10.6335 0.294643 10.3919 0.0669644 10.1004 0.0401786C9.83797 0.0178572 9.57556 0.00446422 9.309 0.00446422V0Z",
    fill: "#07051B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightOn);
export default __webpack_public_path__ + "static/media/night_on.dd52d8becda1585c1f8df3aa1214f241.svg";
export { ForwardRef as ReactComponent };